import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarCollapsed: false,
    theme: 'light',
    modalVisible: {},
    drawerVisible: {},
  },
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action) => {
      state.sidebarCollapsed = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
    },
    showModal: (state, action) => {
      state.modalVisible[action.payload] = true;
    },
    hideModal: (state, action) => {
      state.modalVisible[action.payload] = false;
    },
    showDrawer: (state, action) => {
      state.drawerVisible[action.payload] = true;
    },
    hideDrawer: (state, action) => {
      state.drawerVisible[action.payload] = false;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarCollapsed,
  setTheme,
  showModal,
  hideModal,
  showDrawer,
  hideDrawer,
} = uiSlice.actions;

export default uiSlice.reducer;
